export default __webpack_public_path__ + "static/media/O_wdt_c_cap_2.b28d13d0.mp3";